<template>
  <div class="workOrder">
    <div class="tabNav">
      <span
        class="build"
        :class="{ activeTab: activeColor == 1 }"
        @click="changeTab(1)"
        >我创建的</span
      >
      <span
        class="recive"
        :class="{ activeTab: activeColor == 2 }"
        @click="changeTab(2)"
        >我受理的</span
      >
    </div>
    <div class="serch-wrap">
      <el-form :inline="true" :model="orderForm" class="demo-form-inline">
        <el-form-item label="工单类型">
          <el-select v-model="orderForm.type" clearable placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单状态">
          <el-select
            v-model="statusArr"
            multiple
            collapse-tags
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" class="key-form">
          <el-input class="key-input" v-model="order_keyContent"> </el-input>
          <el-select
            v-model="order_key"
            clearable
            placeholder="请选择"
            class="key-select"
            @change="selectChange"
          >
            <el-option
              v-for="item in keyList"
              :key="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" class="create-time">
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            v-model="date"
            @focus="focusTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchOrderList" size="small"
            >查询</el-button
          >
          <el-button size="small" type="primary" @click="resetOrder"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="add-but">
      <el-button type="primary" size="small" @click="handleAdd()"
        >新建</el-button
      >
    </div>
    <el-dialog
      custom-class="work-create-dialog"
      title="创建工单"
      append-to-body
      center
      :visible.sync="isShowAdd"
      top="250px"
      width="600px"
      @close="closeAdd"
    >
      <div class="exportbtnbox">
        <div class="box1">
          <i>*</i><span style="width:65px">来源单号</span>
          <el-input
            type="textarea"
            autosize
            resize="none"
            placeholder="只能输入字母和数字(长度不超过30)"
            onkeyup="this.value=this.value.replace(/[^\w_]/g,'')"
            maxlength="30"
            show-word-limit
            @input="check"
            v-model="build.businessKey"
            :disabled="sourceAsMsg"
          ></el-input>
        </div>
        <div class="box2">
          <i>*</i><span>问题类型</span>
          <div>
            <el-cascader
              v-model="build.problemTypes"
              :options="options"
              clearable
              filterable
              class="cascader"
              placeholder="请选择问题类型"
              @change="handleChange"
            />
            <el-tooltip placement="top">
              <div slot="content">
                <div>{{ descPrompt }}</div>
              </div>
              <span class="el-icon-question pointer" />
            </el-tooltip>
          </div>
        </div>
        <div class="box1 box-descript">
          <i>*</i><span style="width:65px;margin-left: 2px;">问题描述</span>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入实物型号、品牌、（实收）数量、商品现状描述、具体破损位置、不符合退换原因、客户姓名地址手机号、承运商、收费价格及原因"
            v-model="build.description"
          ></el-input>
        </div>
        <div class="box-img">
          <span>上传图片</span>
          <!-- action="http://dev.nagy.ruigushop.com/exception-order/image" -->
          <el-upload
            class="img-upload"
            :action="addImgUrl"
            :headers="headers"
            list-type="picture-card"
            :auto-upload="true"
            :limit="5"
            :before-upload="beforeAvatarUpload"
            :on-success="successImg"
            :file-list="fileList"
            :on-exceed="exce"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!build.disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="build.dialogVisible">
            <img width="100%" :src="build.dialogImageUrl" alt="" />
          </el-dialog>
        </div>
        <div class="img-info">（最多支持上传5张）</div>
        <!-- 上传视频 -->
        <div class="box-img">
          <span>上传视频</span>
          <!-- action="http://dev.nagy.ruigushop.com/exception-order/image" -->
          <el-upload
            class="img-upload video-upload"
            :action="addVideoUrl"
            :headers="headers"
            list-type="picture-card"
            :auto-upload="true"
            :limit="3"
            :before-upload="beforeAvatarUploadVideo"
            :on-success="successVideo"
            :file-list="videoList"
            :on-exceed="exceVideo"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <video
                v-bind:src="file.url"
                class="avatar video-avatar"
                controls="controls"
                style="width: 100%;"
              >
                您的浏览器不支持视频播放
              </video>
              <span class="el-upload-list__item-video">
                <span v-if="!build.disabled" @click="handleRemoveVideo(file)">
                  <i
                    class="el-icon-error"
                    style="color:#333;cursor: pointer;"
                  ></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="img-info">（最多支持上传3个视频）</div>

        <div class="add-margin">
          <el-button type="primary" class="button-bg-color" @click="saveAdd"
            >提 交</el-button
          >
          <el-button @click="closeAdd">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-table
      max-height="600"
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
      <el-table-column prop="exceptionOrderNo" label="工单号" width="180">
      </el-table-column>
      <el-table-column prop="exceptionTypeDesc" label="工单类型">
      </el-table-column>
      <!-- :formatter="formStatus" -->
      <el-table-column prop="statusDesc" label="工单状态"> </el-table-column>
      <el-table-column prop="createdByName" label="创建人"> </el-table-column>
      <el-table-column prop="operatorName" label="受理人"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="rejectOrder"
            @click="getOrderDetail(scope.row)"
            :class="
              scope.row.exceptionOrderNo === exceptionOrderNo
                ? 'isActive'
                : 'noActive'
            "
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="size"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :pager-count="11"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElements"
      v-if="totalElements"
    >
    </el-pagination>
  </div>
</template>

<script>
import { changeDate } from "@/utils/utils";
import {
  getWorkOrder,
  getWorkOrderHandle,
  buildWorkOrder,
  addImg,
  addVideo,
  newWorkOrderType,
  secondWorkOrderType
} from "@/models/exceptionModel";

export default {
  name: "workOrder",
  data() {
    return {
      imgArr: [],
      videoArr: [], //视频文件
      fileList: [],
      videoList: [], //视频文件
      addImgUrl: addImg,
      addVideoUrl: addVideo,
      headers: {
        Authorization: localStorage.getItem("token")
      },
      activeColor: 1,
      isShowAdd: false,
      tableData: [],
      page: 1,
      size: 10,
      totalElements: 0,
      loading: false,
      options: [],
      descPrompt: "",
      build: {
        businessKey: null,
        description: null,
        problemTypes: [],
        dialogImageUrl: [],
        dialogVisible: false,
        disabled: false
      },
      isVisibled: true,
      order_key: "工单号",
      order_keyContent: "",
      date: null,
      statusArr: [1, 2, 3, 4], // 工单状态多选-默认显示
      orderForm: {
        type: null,
        status: null,
        startDate: "",
        endDate: "",
        exceptionOrderNo: "",
        sourceNumber: ""
      },
      typeList: [],
      statusList: [
        /*0 已撤销
        1 新建
        2 开始处理
        3 已处理
        4 驳回处理
        99 已完成 */
        {
          value: 1,
          label: "新建"
        },
        {
          value: 2,
          label: "开始处理"
        },
        {
          value: 3,
          label: "已处理"
        },
        {
          value: 4,
          label: "驳回处理"
        },
        {
          value: 99,
          label: "已完成"
        },
        {
          value: 0,
          label: "已撤销"
        }
      ],
      keyList: [
        {
          value: "工单号"
        },
        {
          value: "来源单号"
        }
      ],
      exceptionOrderNo: "",
      sourceAsMsg: false //来自售后消息
    };
  },
  methods: {
    // 搜索条件 关键字发生改变时清空对应内容
    selectChange() {
      // this.order_keyContent = ''
      this.orderForm.exceptionOrderNo = "";
      this.orderForm.sourceNumber = "";
    },
    // 创建 or 受理 函数封装  默认1（我创建的） 2（我受理的）
    piceWorkOrder() {
      // console.log(this.statusArr);
      this.tableData = [];
      if (this.order_key === "工单号") {
        this.orderForm.exceptionOrderNo = this.order_keyContent.trim();
      } else if (this.order_key === "来源单号") {
        this.orderForm.sourceNumber = this.order_keyContent.trim();
      }
      this.orderForm = {
        ...this.orderForm,
        status: this.statusArr.join(","),
        page: this.page - 1,
        size: this.size
      };
      if (this.activeColor == 2) {
        getWorkOrderHandle(
          `${localStorage.getItem("supplier_id")}`,
          this.orderForm
        )
          .then(res => {
            this.loading = false;
            // console.log(res.content);
            this.tableData = res.content;
            this.totalElements = res.totalElements;
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
      } else if (this.activeColor == 1) {
        getWorkOrder(`${localStorage.getItem("supplier_id")}`, this.orderForm)
          .then(res => {
            this.loading = false;
            // console.log(res.content);
            this.tableData = res.content;
            this.totalElements = res.totalElements;
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
      }
    },
    // Tab切换
    changeTab(index) {
      this.page = 1;
      this.size = 10;
      if (index === 2) {
        // 我受理的
        this.statusArr = [1, 4];
      } else {
        this.statusArr = [1, 2, 3, 4];
      }
      this.orderForm = {};
      this.order_keyContent = "";
      this.order_key = "工单号";
      this.date = null;
      this.totalElements = 0;
      this.loading = true;
      this.activeColor = index;
      this.piceWorkOrder();
    },
    // 时间范围更改时清空之前的时间 不然报错
    focusTime() {
      this.date = "";
    },
    // 查询
    searchOrderList() {
      this.page = 1;
      this.loading = true;
      if (this.date) {
        this.orderForm.startDate = changeDate(this.date[0]);
        this.orderForm.endDate = changeDate(this.date[1]);
      }
      this.piceWorkOrder();
    },
    // 重置
    resetOrder() {
      this.page = 1;
      this.size = 10;
      this.statusArr = [1, 2];
      this.orderForm = {};
      this.order_keyContent = "";
      this.order_key = "工单号";
      this.date = null;
      this.piceWorkOrder();
    },
    // 新建 新建按钮点击
    handleAdd(sourceNo) {
      if (sourceNo) {
        this.sourceAsMsg = true;
        this.$set(this.build, "businessKey", sourceNo);
      } else {
        this.sourceAsMsg = false;
        this.$set(this.build, "businessKey", "");
      }
      this.$nextTick(() => {
        this.isShowAdd = true;
      });

      newWorkOrderType({
        tag: "diablo-exception-type"
      }).then(res => {
        const list = res;
        list.forEach(item => {
          item.value = item.workOrderType;
          item.label = item.workOrderTypeDesc;
          item.children = item.mapping;
          item.mapping.forEach(v => {
            v.value = v.exceptionType;
            v.label = v.exceptionTypeDesc;
          });
        });
        this.options = list;
      });
    },
    handleChange(array) {
      if (array.length) {
        const [one, two] = array;
        const obj = this.options.find(v => v.value === one);
        const json = obj.mapping.find(v => v.value === two);
        this.descPrompt = json.desc;
      } else {
        this.descPrompt = "";
      }
    },
    // 新建的关闭和取消
    closeAdd() {
      this.isShowAdd = false;
      this.imgArr = [];
      this.videoArr = []; //视频文件
      this.fileList = [];
      this.videoList = []; //视频文件
    },
    check(val) {
      if (val.length >= 30) {
        this.$message.warning("只输入售后单号或订单号即可");
      }
    },
    // 新建的确认
    saveAdd() {
      if (
        this.build.businessKey &&
        this.build.problemTypes.length &&
        this.build.description
      ) {
        const [workOrderType, exceptionType] = this.build.problemTypes;
        let params = {
          createdByName: localStorage.getItem("username"),
          businessKey: this.build.businessKey.trim(),
          workOrderType,
          exceptionType,
          description: this.build.description,
          imgs: this.imgArr, // 图片数组
          supplierId: localStorage.getItem("supplier_id"),
          targetSystem: 1,
          sourceSystem: 5,
          videoList: this.videoArr // 视频数组
        };
        // console.log("params:", params);
        // return false;
        this.loading = true;
        buildWorkOrder(params)
          .then(res => {
            if (res) {
              this.isShowAdd = false;
              this.build = {};
              this.$message({
                message: `工单创建成功，单号为${res}。请到“锐锢在线-工单管理-我创建的”下查看。`,
                type: "success",
                duration: 6000
              });
              this.piceWorkOrder();
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
      } else {
        this.$message({
          message: "请务必填写来源单号,问题类型,问题描述",
          type: "error"
        });
      }
    },
    //上传时，判断文件的类型及大小是否符合规则
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.warning("上传头像图片只能是 JPG/PNG/GIF 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.warning("上传头像图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isJPG && isLt2M;
    },
    //上传视频时，判断文件的类型及大小是否符合规则
    beforeAvatarUploadVideo(file) {
      // console.log("file---", file);
      const isVideo =
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) > -1;
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isVideo) {
        this.$message.warning("请上传正确的视频格式!");
        return isVideo;
      }
      if (!isLt20M) {
        this.$message.warning("视频大小不能超过20MB!");
        return isLt20M;
      }
      return isVideo && isLt20M;
    },
    successImg(res, file) {
      // console.log(res, file, "suc");
      this.imgArr.push(file.response.data);
      this.fileList.push(file);
    },

    successVideo(res, file) {
      // console.log(res, file, "suc--------");
      if (res.code == 200) {
        this.videoArr.push(file.response.data.url);
        this.videoList.push(file);
      }
    },
    exce() {
      this.$message.warning("最多上传5张图片！");
    },
    exceVideo() {
      this.$message.warning("最多上传3个视频！");
    },
    // 删除按钮
    handleRemove(file) {
      this.imgArr = this.imgArr.filter(item => {
        return item != file.response.data;
      });
      const filePath = file.url;
      const i = this.fileList.findIndex(x => x.url === filePath);
      this.fileList.splice(i, 1);
    },

    // 删除按钮
    handleRemoveVideo(file) {
      this.videoArr = this.videoArr.filter(item => {
        return item != file.response.data;
      });
      const filePath = file.url;
      const i = this.videoList.findIndex(x => x.url === filePath);
      this.videoList.splice(i, 1);
    },
    handlePictureCardPreview(file) {
      this.build.dialogImageUrl = file.url;
      this.build.dialogVisible = true;
    },

    // 每页条数
    handleSizeChange(val) {
      this.loading = true;
      this.size = val;
      this.page = 1;
      this.piceWorkOrder();
    },
    // 页码改变
    handleCurrentChange(val) {
      this.loading = true;
      this.page = val;
      this.piceWorkOrder();
    },
    // 查看
    getOrderDetail(scope) {
      console.log(scope);
      this.exceptionOrderNo = scope.exceptionOrderNo;
      this.$router.push({
        path: "/orderList/detail",
        query: {
          exceptionOrderNo: scope.exceptionOrderNo,
          activeColor: this.activeColor
        }
      });
    },
    formType(row) {
      return row.type === 1
        ? "售后问题"
        : row.type === 2
        ? "订单问题"
        : row.type === 3
        ? "发票问题"
        : row.type === 4
        ? "账户问题"
        : row.type === 5
        ? "产品问题"
        : row.type === 6
        ? "其它问题"
        : "";
    },
    formStatus(row) {
      return row.status === 0
        ? "已撤销"
        : row.status === 1
        ? "新建"
        : row.status === 2
        ? "开始处理"
        : row.status === 3
        ? "已处理"
        : row.status === 4
        ? "驳回处理"
        : row.status === 99
        ? "已完成"
        : "";
    },
    // 从三方备货出库单 拒收订单创建工单进入 自动出现 创建工单弹窗 并 带入来源单号
    autoCreate() {
      this.build.businessKey = this.$route.query.main_number;
      this.isShowAdd = true;
      newWorkOrderType({
        tag: "diablo-exception-type"
      }).then(res => {
        const list = res;
        list.forEach(item => {
          item.value = item.workOrderType;
          item.label = item.workOrderTypeDesc;
          item.children = item.mapping;
          item.mapping.forEach(v => {
            v.value = v.exceptionType;
            v.label = v.exceptionTypeDesc;
          });
        });
        this.options = list;
      });
    }
  },
  created() {
    const fromIndex = this.$route.query.activeColor;
    //console.log(fromIndex, "fromIndex2222");
    this.activeColor = Number(fromIndex) || 1;
    // 搜索框工单类型的请求接口
    secondWorkOrderType().then(res => {
      // console.log(res);
      Object.keys(res).forEach(key => {
        this.typeList.push({
          value: key,
          label: res[key]
        });
      });
    });
    this.piceWorkOrder();
    // 从三方备货出库单 拒收订单创建工单进入 自动出现 创建工单弹窗 并 带入来源单号
    const { main_number, type } = this.$route.query;
    if (type == "order_create" && main_number) {
      this.autoCreate();
    }
    // 从售后消息过来，自动弹出创建工单弹框，并带上来源单号(2023-10-08 更新)
    // console.log("---created-----------------", this.$route.query);
    if (this.$route.query && this.$route.query.sourceNo) {
      this.handleAdd(this.$route.query.sourceNo);
    }
  },

  watch: {
    $route(to, from) {
      if (this.$route.query && this.$route.query.sourceNo) {
        this.handleAdd(this.$route.query.sourceNo);
      }
      //  console.log("watch", to, from)
      if (to.query && to.query.activeColor === "2") {
        // 从数据看板处点击过来
        this.changeTab(2);
      } else {
        this.changeTab(1);
      }
      if (
        from.path == "/order/manage" &&
        to.path == "/orderList/work" &&
        this.$route.query.main_number &&
        this.$route.query.type == "order_create"
      ) {
        this.autoCreate();
      }
    }
  },
  filters: {
    typeFilter(value) {
      const valueObj = {
        1: "退货",
        2: "换货",
        3: "维修"
      };
      return valueObj[value];
    }
  }
};
</script>

<style lang="scss">
.tabNav {
  line-height: 50px;
  margin-top: 5px;
  span {
    display: inline-block;
    width: 150px;
    text-align: center;
    background-color: #f5f7fa;
    cursor: pointer;
  }
  span:hover {
    background-color: #ff6224;
    color: #fff;
  }
  span.activeTab {
    background-color: #ff6224;
    color: #fff;
  }
}

.serch-wrap {
  margin: 5px 0 15px;
}

.el-table .el-button {
  color: red;
}

.key-form {
  margin-right: 35px !important;
  > div {
    position: relative;
    width: 200px;
  }
}

.key-input {
  position: absolute;
  width: 140px;
  left: 75px;
}

.key-select {
  width: 85px;
}

.exportbtnbox {
  text-align: center;
  .box1 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    width: 90%;
    .el-textarea {
      width: 70%;
      margin-left: 10px;
    }
    i {
      color: red;
    }
  }
  .box-descript {
    align-items: flex-start;
  }
  .box2 {
    width: 88%;
    height: 50px;
    margin-left: 65px;
    position: relative;
    > i {
      position: absolute;
      top: 9px;
      left: 0;
      color: red;
    }
    > span {
      position: absolute;
      left: 13px;
      top: 9px;
    }
    .el-select {
      width: 46%;
      position: absolute;
      left: 83px;
      .el-input {
        width: 74%;
      }
    }
    .secondType {
      left: 266px;
    }
    .isVisible {
      display: none;
    }
    .cascader {
      width: 300px;
      .el-input {
        width: 100%;
      }
    }
  }
  .box-img {
    text-align: left;
    justify-content: flex-start;
    align-items: start;
    margin-left: 79px;
    > span {
      margin-right: 15px;
      width: 77px;
    }
    .img-upload {
      margin-left: 70px;
    }
    i {
      color: #8c939d;
    }
  }
  .img-info {
    text-align: left;
    margin-left: 140px;
  }
  .el-button {
    padding: 10px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    .inputfile {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .el-button:hover {
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.add-margin {
  margin-top: 40px;
}

.button-bg-color {
  background-color: #ff6224 !important;
  border-color: #ff6224 !important;
  color: #fff !important;
}

.add-but {
  height: 26px;
  margin-bottom: 10px;
  .el-button {
    float: right;
  }
}

.el-select-dropdown {
  min-width: 164.719px !important;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 90px;
  height: 90px;
}
.video-upload {
  .el-upload--picture-card,
  .el-upload-list--picture-card .el-upload-list__item {
    width: 128px;
    height: auto;
  }
}

.el-upload--picture-card {
  line-height: 103px;
}
.work-create-dialog {
  border-radius: 10px;

  .el-dialog__header {
    background-color: #fff !important;
    text-align: left;
    padding: 20px 20px 0 !important;
    border-radius: 10px;
    position: relative;
    .el-dialog__title {
      color: #303133 !important;
      font-weight: bold;
    }
  }

  .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
    position: absolute;
    right: 10px;
    top: 15px;
  }
  .el-upload-list__item-video {
    position: absolute;
    width: 16px;
    z-index: 99;
    height: 16px;
    right: 0;
    top: 0;
    i {
    }
  }
}

.create-time {
  position: relative;
  width: 418px;
  .el-form-item__content {
    position: absolute;
    top: 2px;
    .el-input__inner {
      height: 26px;
      line-height: 26px;
      .el-range-input {
        font-size: 12px;
      }
      .el-range__icon,
      .el-range-separator,
      .el-range__close-icon {
        line-height: 20px;
      }
    }
  }
}
.isActive {
  color: green !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderForChat/workOrder.vue